import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {Dictionary} from "../../../../types/rendering";
import LiveChatState from "../livechat-state";


export default class ErrorMutator
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _stateManager: LiveChatState;


    //#region Public Interface

    constructor(settings: DefaultSettings, stateManager: LiveChatState)
    {
        this._settings = settings;
        this._stateManager = stateManager;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    getReducer()
    {
        return (state = defaultState): AlmeState => state;
    }

    getMutator()
    {
        return (parameters: Dictionary): Dictionary =>
        {
            if (!this._stateManager.isOnline) { return parameters; }

            return { ...parameters, className: this._settings.classNames.livechat.responseError };
        };
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/renderers/error-mutator.ts